module.exports = __webpack_public_path__ + "static/bayareakids-49570ef65dc3338259f39fed7272fff0.jpg";